import {
    Component,
    DestroyRef,
    inject,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, distinctUntilChanged } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppConsts } from '@vadmin/account/auth/app-consts';

@Component({
    selector: 'content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ContentComponent {
    private readonly router = inject(Router);
    private readonly destroyRef = inject(DestroyRef);

    readonly disableInteraction = signal<boolean>(abp.setting.get(AppConsts.Settings.ApplicationVersion) === "2.0");

    constructor() {
        this.router.events
            .pipe(
                filter((e): e is NavigationEnd => e instanceof NavigationEnd),
                map(() => this.router.url),
                distinctUntilChanged(),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(url => {
                this.disableInteraction.set(
                      abp.setting.get(AppConsts.Settings.ApplicationVersion) === "2.0" && !url.startsWith('/settings/subscription-details')
                );
            });
    }
}